
import '../scss/style.scss';
import './jquery.menu.aim';

const { CssAnimation } = RS;

const DEFAULT_PARAMS = {
	aim: true,
	exitDelay: 500,
	resizeMedia: '(min-width: 1200px)',
	cssClasses: {
		menu: 'menu-horizontal',
		menuItem: 'menu-horizontal__item',
		menuLink: 'menu-horizontal__link',
		menuItemActive: 'menu-horizontal__item--active',
		dropdown: 'menu-horizontal__dropdown',
		dropdownRight: 'menu-horizontal__dropdown--right',
		megamenu: 'menu-horizontal__megamenu',
	}
};

export class MenuHorizontal extends BX.Event.EventEmitter
{
	static get Events()
	{
		return {
			READY: 'onReady',
			REVEAL: 'reveal',
			CONCEAL: 'conceal'
		};
	}

	static get EventNamespace()
	{
		return 'EShop24.MenuHorizontal';
	}

	constructor(element, params)
	{
		super();
		this.setEventNamespace(MenuHorizontal.EventNamespace);

		this.element = element;
		this.params = { ...DEFAULT_PARAMS, ...params };

		window.addEventListener('resize', BX.debounce(this.resize.bind(this), 100));

		if (this.params.aim && $.fn.menuAim)
			this.initAim();
		else
			this.initBase();

		this.initTouch();
		this.initKeyboard();

		BX.Event.EventEmitter.emit(
			window,
			`${MenuHorizontal.EventNamespace}.${MenuHorizontal.Events.READY}`,
			this
		);
	}

	initBase()
	{
		this.element.addEventListener(
			'mouseenter',
			({ target }) => {
				if (target.querySelector(`.${this.params.cssClasses.dropdown}, .${this.params.cssClasses.megamenu}`))
					this.reveal(target);
			},
			true
		);

		this.element.addEventListener(
			'mouseleave',
			({ target }) => {
				if (target !== document && target.matches(`.${this.params.cssClasses.menuItem}`))
					this.conceal(target);
			},
			true
		);
	}

	initAim()
	{
		const items = this.element.querySelectorAll(`.${this.params.cssClasses.menuItem}`)
		let tId = null;

		const activateHandler = row => {

			[...items]
				.filter(
					item =>
						item.matches(`.${this.params.cssClasses.menuItemActive}`) &&
						item !== row && !item.contains(row) && !row.contains(item)
				)
				.forEach(item => this.conceal(item));

			// if (row.querySelector('.menu-horizontal__dropdown') || row.closest('.menu-horizontal__dropdown'))
			// 	__app__.Backdrop.add();
			// else
			// 	__app__.Backdrop.release();

			this.reveal(row);
		};

		const deactivateHandler = row => {
			setTimeout(() => {
				if (!tId)
					this.conceal(row);
			})
		};

		const aimOptions = {
			rowSelector: `> .${this.params.cssClasses.menuItem}`,
			activate: activateHandler,
			deactivate: deactivateHandler,
			exitMenu: () => true
		};

		$(this.element).menuAim(aimOptions);
		$(this.element).find(`.${this.params.cssClasses.dropdown}`).menuAim(aimOptions);

		this.element.addEventListener('mouseenter', () => {
			clearTimeout(tId);
			tId = null;
		});

		this.element.addEventListener('mouseleave', () => {
			tId = setTimeout(() => {
				clearTimeout(tId);
				this.close()
				// __app__.Backdrop.release();
			}, this.params.exitDelay);
		});
	}

	initTouch()
	{
		const touchedItems = new WeakSet();
		let touched = false;

		this.element.addEventListener(
			'touchstart',
			() => { touched = true },
			{ capture: true, passive: true }
		);

		this.element.addEventListener(
			'touchend',
			() => { setTimeout(() => { touched = false }); },
			true
		);

		const links = this.element.querySelectorAll(`.${this.params.cssClasses.menuLink}`);
		[...links].forEach(link => {
			const item = link.parentNode;
			if (item.querySelector(`.${this.params.cssClasses.dropdown}, .${this.params.cssClasses.megamenu}`))
			{
				link.addEventListener('click', event => {
					if (touched && !touchedItems.has(item))
					{
						touchedItems.add(item);
						event.preventDefault();
					}
					else if (touched)
					touchedItems.delete(item);
				});
			}
		});

		this.subscribe(MenuHorizontal.Events.CONCEAL, ({ data }) => {
			touchedItems.delete(data.item);
		});
	}

	initKeyboard()
	{
		let focusIn = false;
		const allItems = this.element.querySelectorAll(`.${this.params.cssClasses.menuItem}`);
		const activeFocusItems = new WeakSet();

		this.element.addEventListener(
			'keydown',
			(event) => {
				const { target } = event;
				if (
					event.code === 'Enter' &&
					target.matches(`.${this.params.cssClasses.menuLink}`)
				)
				{
					const targetItem = target.parentNode;
					if (
						!activeFocusItems.has(targetItem) &&
						targetItem.querySelector(`.${this.params.cssClasses.dropdown}, .${this.params.cssClasses.megamenu}`)
					)
					{
						event.preventDefault();

						this.reveal(targetItem);
						activeFocusItems.add(targetItem);
					}
				}

				if (event.code === 'Escape' || event.code === 'Esc')
				{
					const activeItems = [...allItems].filter(item => item.matches(`.${this.params.cssClasses.menuItemActive}`));
					if (activeItems.length >= 2)
					{
						activeItems[activeItems.length - 1].querySelector(`.${this.params.cssClasses.menuLink}`).focus();
						this.conceal(activeItems[activeItems.length - 1]);
					}
					else if (activeItems.length === 1)
					{
						activeItems[0].querySelector(`.${this.params.cssClasses.menuLink}`).focus();
						this.conceal(activeItems[0]);
					}
				}
			},
			true
		);

		this.element.addEventListener(
			'focusin',
			event => {
				focusIn = true;

				const { target } = event;
				const targetItem = target.parentNode;

				[...allItems]
					.filter(
						item =>
							item.matches(`.${this.params.cssClasses.menuItemActive}`) &&
							item !== targetItem && !item.contains(targetItem) && !targetItem.contains(item)
					)
					.forEach(item => this.conceal(item));
			}
		);

		document.addEventListener(
			'focusin',
			({ target }) => {
				if (focusIn && !this.element.contains(target))
				{
					this.close();
					focusIn = false;
				}
			},
			false
		);

		this.subscribe(MenuHorizontal.Events.CONCEAL, ({ data }) => {
			activeFocusItems.delete(data.item);
		});
	}

	resize()
	{
		if(
			!this.params.resizeMedia ||
			!window.matchMedia(this.params.resizeMedia).matches
		)
			return;

		horizontalMenuResizer(this.element);
	}

	close()
	{
		const activeItems = this.element.querySelectorAll(`.${this.params.cssClasses.menuItemActive}`);
		[...activeItems].forEach(item => {
			this.conceal(item);
		});
	}

	reveal(item)
	{
		const target = item.querySelector(`.${this.params.cssClasses.dropdown}, .${this.params.cssClasses.megamenu}`);

		if (target)
		{
			if (target.matches(`.${this.params.cssClasses.dropdown}`))
			{
				Object.assign(target.style, {
					display: 'block',
					visibility: 'hidden'
				});

				const bodyWidth = document.body.getBoundingClientRect().width;
				const targetRect = target.getBoundingClientRect();

				if (targetRect.right > bodyWidth)
					target.classList.add(this.params.cssClasses.dropdownRight);

				target.style.removeProperty('display');
				target.style.removeProperty('visibility');
			}

			if (target.matches(`.${this.params.cssClasses.megamenu}`))
			{
				Object.assign(target.style, {
					display: 'block',
					visibility: 'hidden'
				});

				const targetRect = target.getBoundingClientRect();
				if (targetRect.bottom >= window.innerHeight)
					target.style.maxHeight = (window.innerHeight - targetRect.top - 10) + 'px';

				target.style.removeProperty('display');
				target.style.removeProperty('visibility');
			}

			if (!item.classList.contains(this.params.cssClasses.menuItemActive))
			{
				target.classList.remove('conceal-animation');
				CssAnimation.triggerAnimation(target, 'reveal-animation');
			}
		}

		item.classList.add(this.params.cssClasses.menuItemActive);
		this.emit(MenuHorizontal.Events.REVEAL, { item });
	}

	conceal(item)
	{
		const target = item.querySelector(`.${this.params.cssClasses.dropdown}, .${this.params.cssClasses.megamenu}`);
		if (target)
		{
			target.classList.remove('reveal-animation');
			CssAnimation.triggerAnimation(target, 'conceal-animation')
				.then(() => {
					target.style.removeProperty('max-height');
					if (target.matches(this.params.cssClasses.dropdownRight))
						target.classList.remove(this.params.cssClasses.dropdownRight);
					item.classList.remove(this.params.cssClasses.menuItemActive);
				});
		}
		else
			item.classList.remove(this.params.cssClasses.menuItemActive);

		this.emit(MenuHorizontal.Events.CONCEAL, { item });
	}
}
